import { HTMLProps } from 'react';

import FilterSummary from './FilterSummary';

export interface FilterSummaryProps extends HTMLProps<HTMLDivElement> {
	numberEntries: number;
}

export default FilterSummary;